import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
   isAuthenticated: boolean;
}

export const ProtectedRoute = ({ isAuthenticated }: ProtectedRouteProps) => {
  if (!isAuthenticated) {
    console.log("Redirecting to signin, not authenticated");
    return <Navigate to="/signin" replace />;
  }
  console.log("Rendering outlet, authenticated");

  return <Outlet />;
};